import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import {
  MatPaginatorModule,
  MatPaginator,
  PageEvent,
} from '@angular/material/paginator';
import { MatSortModule, MatSort, Sort } from '@angular/material/sort';
import { CommonModule, Location } from '@angular/common';
import { OrdersService } from '../../core/services/orders/orders.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormAddOrderComponent } from './form-add-order/form-add-order.component';
import { AlertService } from '../../core/services/alert/alert.service';
import { Orders } from '../../core/interfaces/orders';
import { UI_DELAYS } from '../../core/constants/time.constants';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientsService } from '../../core/services/clients/clients.service';
import { LocalStorageService } from '../../core/services/localStorage/local-storage.service';
import { AccountsService } from '../../core/services/accounts/accounts.service';
import { UsersService } from '../../core/services/users/users.service';
import { DocumentsTypeService } from '../../core/services/documentType/documents-type.service';
import { BrandService } from '../../core/services/brand/brand.service';

import { Title } from '@angular/platform-browser';
import { FormAddClientComponent } from '../clients/form-add-client/form-add-client.component';
import { DataService } from '../../core/services/orders/data.service';
import { FormShowAssigneeComponent } from '../shared/form-show-assignee/form-show-assignee.component';
import { FormAddAssigneeComponent } from '../clients/form-add-client/form-add-assignee/form-add-assignee.component';
import { FormAddOrderPdfComponent } from "./form-add-order-pdf/form-add-order-pdf.component";
import { FormUpdateExcelComponent } from './form-update-excel/form-update-excel.component';
import { AddressesFormComponent } from "./form-add-order/addresses-form/addresses-form.component";
import { SendMailPanelComponent } from "./form-add-order/send-mail-panel/send-mail-panel.component";
import { CallPanelComponent } from "../shared/call-panel/call-panel.component";

import Swal from 'sweetalert2';
import { AuthStateService } from '../../core/services/auth-state/auth-state-service.service';
import { CampaignsService } from '../../core/services/campaigns/campaigns.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Observable, forkJoin, Subject } from 'rxjs';
import { map, catchError, takeUntil } from 'rxjs/operators';
import { of } from 'rxjs';
import { SharedFilterComponent } from '../shared/shared-filter/shared-filter.component';
// ✅ FASE B6: SelectionModel eliminado (ahora en OrdersSelectionService)
import { MatDialog } from '@angular/material/dialog';

// Nuevos servicios para refactorización
import { OrdersStateService } from '../../core/services/orders/orders-state.service';
import { OrdersExportService } from '../../core/services/orders/orders-export.service';
import { OrdersRouteService } from '../../core/services/orders/orders-route.service';
import { OrdersSelectionService } from '../../core/services/orders/orders-selection.service';
import { OrdersAlertService } from '../../core/services/orders/orders-alert.service';
import { KeyboardShortcutService } from '../../core/services/keyboard/keyboard-shortcut.service';
import { VisibilityPollingService } from '../../core/services/visibility-polling/visibility-polling.service';

// Nuevos componentes para refactorización
import { OrdersActionsBarComponent } from './orders-actions-bar/orders-actions-bar.component';
import { OrdersTableComponent } from './orders-table/orders-table.component';

interface AccountData {
  reference: string;
  name: string;
  type: string;
  tax_id: string;
  billing_address: string;
  billing_city: string;
  billing_state: string;
  root_account: any;
  status: boolean;
}
interface ApiResponse {
  data: AccountData[];
}

@Component({
  selector: 'app-orders',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    TranslateModule,
    FormAddOrderComponent,
    NgSelectModule,
    ReactiveFormsModule,
    MatTooltipModule,
    FormsModule,
    RouterModule,
    FormAddClientComponent,
    FormShowAssigneeComponent,
    FormAddAssigneeComponent,
    FormAddOrderPdfComponent,
    FormUpdateExcelComponent,
    AddressesFormComponent,
    SendMailPanelComponent,
    CallPanelComponent,
    SharedFilterComponent,
    OrdersActionsBarComponent,
    OrdersTableComponent
  ],
  templateUrl: './orders.component.html',
  styleUrl: './orders.component.css',
})

export class OrdersComponent {
  private route = inject(ActivatedRoute);
  private keyboardService = inject(KeyboardShortcutService);
  private destroy$ = new Subject<void>();
  private unregisterShortcuts: (() => void) | null = null;
  
  @ViewChild(FormAddOrderComponent) formAddOrderComponent!: FormAddOrderComponent;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(SharedFilterComponent) sharedFilterComponent!: SharedFilterComponent;

  showForm = false;
  showFormPdf = false;
  showImportExcel = false; // Variable para controlar la visibilidad del formulario de importación

  preTypeOrders: any = 'stages'; // Objeto opcional

  aux_showForm = false;
  showAddressesForm = false;
  showAddClientForm = false;
  showMailPanel = false;
  mailPanelData = { reference: '', email: '', name: '' };
  showCallPanel = false;
  callPanelData = { phone: '', name: '', clientReference: '' };
  showAssigneeForm = false;
  showClear = false;
  pageNumber: number = 1;
  pageSize: number = 100;
  sortColumn = 'updated_at';
  sortDirection = 'asc';
  order_reference?: any;
  orderData?: any;
  typeOrders: string = '';
  dataSource = new MatTableDataSource<Orders>();
  title = 'orders';

  // 🔄 FASE B1: Observables del estado centralizado
  orders$ = this.ordersStateService.orders$;
  loading$ = this.ordersStateService.loading$;
  selectedOrder$ = this.ordersStateService.selectedOrder$;

  // ✅ FASE C1: AlertState delegado a OrdersAlertService
  alertState$ = this.ordersAlertService.alertState$;

  flagFilter = false;
  searchParams: any = {};
  accountType: string | null = null;

  // Propiedades locales de ruta (del routeConfig)
  showAlertFilterAll = false;
  showAlertCancelled = false;

  ladata: any = [];
  cargaladata: any = [];

  stage_type = '';
  filterInitialValues: any = {};

  document_buttons_chico = false;
  tab = 'general';

  displayedColumns: string[] = [];
  type: any = 'broker';
  role: any;

  userRole: string = '';

  // ✅ FASE B5: Rutas centralizadas en OrdersRouteService

  sortMap: { [key: string]: string } = {
    vehicle: 'vehicle',
    vendor: 'vendor',
    client: 'client',
    broker: 'broker',
    supplier: 'supplier',
    supplier_reference: 'supplier_reference',
    broker_reference: 'broker_reference',
    supplier_agent: 'supplier_agent',
    broker_agent: 'broker_agent',
    updated_at: 'updated_at',
    stage_updated_at: 'stage_updated_at',
    stage: 'stage',
    vehicle_manufacturing_date: 'vehicle_manufacturing_date',
    delivery_expected_date: 'delivery_expected_date'

  };

  constructor(
    private orderService: OrdersService,
    private alertService: AlertService,
    private clientService: ClientsService,
    private location: Location,
    private localStorageService: LocalStorageService,
    private accountService: AccountsService,
    private userService: UsersService,
    private documentTypeService: DocumentsTypeService,
    private brandService: BrandService,
    private clientsService: ClientsService,
    private titleService: Title,
    private translate: TranslateService,
    private dataService: DataService,
    private authStateService: AuthStateService,
    private campaignService: CampaignsService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private dialog: MatDialog,
    // Nuevos servicios para refactorización
    public ordersStateService: OrdersStateService,
    public ordersExportService: OrdersExportService,
    public ordersRouteService: OrdersRouteService,
    public ordersSelectionService: OrdersSelectionService,
    public ordersAlertService: OrdersAlertService,
    private visibilityPolling: VisibilityPollingService
  ) {
  }

  ngOnInit() {
    this.detectReference();
    
    // 🔄 FASE B1 Parte 2: Sincronización optimizada del estado → dataSource
    this.ordersStateService.orders$
      .pipe(takeUntil(this.destroy$))
      .subscribe(orders => {
        this.dataSource.data = orders;
      });
    
    const cols = this.authStateService.getDisplayedColumns(this.typeOrders);
    this.displayedColumns = cols;
    this.userRole = this.authStateService.getRole() || '';
    this.detectCurrentRoute();
    this.alertService.loading('swal_messages.please_wait');
    const arrayType = ['contrats', 'all-contracts', 'registering', 'rejected', 'authorized', 'denied', 'cancellation-requested', 'signed-contracts'];
    if (arrayType.includes(this.typeOrders)) {
      this.sortColumn = 'stage_updated_at';
      this.sortDirection = 'asc';
    }
    this.fetchAllData();
    this.startAutoFetch();

  }
  ngAfterViewInit() {
    // Ahora sharedFilterComponent está disponible
    this.flagFilter = this.sharedFilterComponent.checkFilterConfigInLocalStorage();
    if (!this.flagFilter) {
      this.fetchData();
    }
    
    // Forzar detección de cambios para evitar NG0100
    this.cdr.detectChanges();

    this.registerKeyboardShortcuts();
  }

  private registerKeyboardShortcuts(): void {
    this.unregisterShortcuts = this.keyboardService.registerMany([
      {
        key: 'n', alt: true,
        handler: (): boolean | void => {
          if (this.showForm || this.showFormPdf || this.showImportExcel) return false;
          if (this.accountType !== 'broker') return false;
          if (this.typeOrders === 'cancelled' || this.typeOrders === 'frozen') return false;
          this.toggleForm();
          this.cdr.detectChanges();
        },
        description: 'new_order', category: 'navigation', priority: 0,
      },
      {
        key: 'Escape', allowInInput: true,
        handler: () => {
          // Priority: blur focused input → close sub-forms → close main form
          if (this.showForm || this.showFormPdf || this.showImportExcel) {
            const el = document.activeElement as HTMLElement;
            const tag = el?.tagName?.toLowerCase();
            if (tag === 'input' || tag === 'textarea' || tag === 'select' || el?.isContentEditable) {
              el.blur();
              return;
            }
          }
          if (this.showImportExcel) { this.cerrarFormularioExcel(); return; }
          if (this.showFormPdf) { this.cerrarFormularioPdf(); return; }
          if (this.showForm) { this.cerrarFormulario(); return; }
          return false; // Not handled — let other handlers try
        },
        category: 'navigation', description: 'close', priority: 5,
      },
      {
        key: 'f', alt: true,
        handler: (): boolean | void => {
          if (!this.sharedFilterComponent) return false;
          if (this.sharedFilterComponent.showFilterModal) {
            this.sharedFilterComponent.closeFilterModal();
          } else {
            this.sharedFilterComponent.openFilterModal();
          }
        },
        description: 'toggle_filters', category: 'navigation', priority: 0,
      },
    ]);
  }
  ngOnDestroy(): void {
    // Cancelar todas las suscripciones
    this.destroy$.next();
    this.destroy$.complete();
    
    // 🔄 FASE B1: Limpiar estado centralizado
    this.ordersStateService.clear();
    
    // Limpiar atajos de teclado
    this.unregisterShortcuts?.();

    // Limpiar polling visibility-aware
    this.visibilityPolling.unregister('orders-list-refresh');
  }

  /**
   * Carga todos los datos maestros necesarios usando forkJoin para ejecutar las peticiones en paralelo
   * Obtiene todos los datos en una sola llamada y los mapea al formato esperado
   */
  private fetchAllData() {
    forkJoin({
      accounts: this.accountService.getData().pipe(catchError(() => of({ data: [] }))),
      brands: this.brandService.getData().pipe(catchError(() => of({ data: [] }))),
      documentTypes: this.documentTypeService.getSelectType().pipe(catchError(() => of({ data: [] }))),
      agents: this.userService.getUserAgent().pipe(catchError(() => of({ data: [] }))),
      clients: this.clientsService.getData().pipe(catchError(() => of({ data: [] }))),
      stages: this.orderService.getStagesMap(this.typeOrders, this.preTypeOrders).pipe(catchError(() => of({ data: [] }))),
      delivery: this.orderService.getDeliveryData().pipe(catchError(() => of({ data: { places: [], status: [] } }))),
      supplierSellerCodes: this.orderService.getSupplierSellerCodes().pipe(catchError(() => of({ data: [] }))),
      campaigns: this.campaignService.getCampaigns().pipe(catchError(() => of({ data: [] }))),
      telemarketingStatus: this.orderService.getTelemarketingStatus().pipe(catchError(() => of({ data: {} }))),
      telemarketingActionStatus: this.orderService.getTelemarketingActionStatus().pipe(catchError(() => of({ data: {} }))),
      tags: this.orderService.getTags().pipe(catchError(() => of({ data: {} })))
    }).pipe(
      map(results => {
        const accountsData: AccountData[] = results.accounts.data || [];
        
        // Transformar clientes agregando fullname
        const clientsWithFullname = (results.clients.data || []).map((client: any) => ({
          ...client,
          fullname: `${client.name}${client.lastname ? ` ${client.lastname}` : ''}`.trim()
        }));

        return {
          vendorData: accountsData.filter(item => item.type === 'vendor'),
          brokerData: accountsData.filter(item => item.type === 'broker'),
          supplierData: accountsData.filter(item => item.type === 'supplier'),
          workshopData: accountsData.filter(item => item.type === 'workshop'),
          logisticData: accountsData.filter(item => item.type === 'logistic'),
          dealershipData: accountsData.filter(item => item.type === 'dealership'),
          brands: results.brands.data || [],
          selectTypes: results.documentTypes.data || [],
          agentData: results.agents.data || [],
          clientData: clientsWithFullname,
          stages: results.stages.data || [],
          delivery_place: results.delivery.data?.places || [],
          delivery_status: results.delivery.data?.status || [],
          supplier_seller_codes: results.supplierSellerCodes.data || [],
          campaignData: results.campaigns.data || [],
          telemarketing_status: results.telemarketingStatus.data || {},
          telemarketing_action_status: results.telemarketingActionStatus.data || {},
          tags: results.tags.data || {},
          flag: true
        };
      })
    ).pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (masterData) => {
        // Asignar todos los datos a cargaladata
        this.cargaladata = { ...this.cargaladata, ...masterData };
        
        // Asignar datos específicos a propiedades del componente
        this.vendorData = masterData.vendorData;
        this.brokerData = masterData.brokerData;
        this.supplierData = masterData.supplierData;
        this.workshopData = masterData.workshopData;
        this.logisticData = masterData.logisticData;
        this.dealershipData = masterData.dealershipData;
        this.agentData = masterData.agentData;

        setTimeout(() => {
          this.ladata = this.cargaladata;
          this.dataService.setLadata(this.ladata);
          this.showForm = this.aux_showForm;
          this.alertService.close();
          this.cdr.detectChanges();
        }, UI_DELAYS.DATA_LOAD_BUFFER);

        if (this.detectUrl && this.order_reference) {
          const updatedURL = `/orders/${this.typeOrders}/${this.order_reference}`;
          this.location.go(updatedURL);
          this.getOrder(this.order_reference);
        }
      },
      error: (error) => {
        console.error('Error cargando datos maestros:', error);
        this.alertService.close();
        this.alertService.error('swal_messages.error_loading_data');
      }
    });
  }

  private fetchNewData() {
    Promise.all([this.fetchData()]).then(() => {
      this.ladata = this.cargaladata;
      setTimeout(() => {
        this.alertService.close();
      }, UI_DELAYS.ALERT_CLOSE_DELAY);
    });
  }

  agentData: AccountData[] = [];
  vendorData: AccountData[] = [];
  brokerData: AccountData[] = [];
  supplierData: AccountData[] = [];
  workshopData: AccountData[] = [];
  logisticData: AccountData[] = [];
  dealershipData: AccountData[] = [];
  selectTypes: any[] = [];
  brands: any[] = [];
  models: any[] = [];
  expandedRow: any = null;

  // ✅ FASE B2: toggleRow migrado a OrdersTableComponent

  fetchData(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.ordersStateService.setLoading(true);
      this.alertService.loading('swal_messages.please_wait');
      
      this.orderService
        .getData(
          this.typeOrders,
          this.preTypeOrders,
          this.pageNumber,
          this.pageSize,
          this.searchParams,
          this.sortColumn,
          this.sortDirection
        )
        .pipe(
          takeUntil(this.destroy$)
        )
        .subscribe({
          next: (data) => {
            // 🔄 FASE B1 Parte 2: Actualizar estado centralizado (dataSource se sincroniza automáticamente)
            this.ordersStateService.setOrders(data.data);
            this.ordersStateService.setLoading(false);
            
            // dataSource.data ya NO se actualiza aquí - se sincroniza vía suscripción en ngOnInit
            this.cargaladata.flag = true;
            this.dataSource.sort = this.sort;
            this.pageNumber = data.meta.current_page;
            
            if (!this.localStorageService.getItem('per_page')) {
              this.localStorageService.setItem('per_page', data.meta.per_page);
              this.pageSize = data.meta.per_page;
            } else {
              this.pageSize = Number(
                this.localStorageService.getItem('per_page')
              );
            }
            this.paginator.pageSizeOptions = [25, 50, 100];
            this.paginator.pageSize = this.pageSize;
            this.paginator.pageIndex = this.pageNumber - 1;
            this.paginator.length = data.meta.total;

            // Restaurar selecciones basadas en referencias
            this.restoreSelections();
            this.alertService.close();
            resolve();
          },
          error: (error) => {
            this.ordersStateService.setLoading(false);
            this.alertService.error(error.error);
            reject(error);
          },
        });
    });
  }

  startAutoFetch(): void {
    this.visibilityPolling.register('orders-list-refresh', () => {
      if (!this.showForm && !this.data_est) {
        this.refreshOrdersData();
      }
    }, 40000);
  }

  // ✅ FASE C1: Getter para data_est desde servicio
  get data_est(): boolean {
    return this.ordersAlertService.currentState.data_est;
  }

  getOrderRing(order: any) {
    this.tab = 'notes';
    this.getOrder(order);
  }
  getOrderPdf(reference: any) {
    this.showFormPdf = false;
    this.getOrder(reference);
  }

  finishImport(reference: any) {
    this.showImportExcel = false;
    this.alertService.successOk('swal_messages.import_success');
  }

  private forceTab: string | null = null;

  openOrderNotes(reference: string): void {
    this.forceTab = 'notes';
    this.getOrder(reference);
  }

  getOrder(reference: string): void {
    this.alertService.loading('swal_messages.please_wait');
    const nuevaURL = this.location.path();

    var aux = this.typeOrders == '' ? this.typeOrders : this.typeOrders + '/';

    if (!nuevaURL.includes('orders')) {
      const nuevaURL = this.location.path() + '/orders/' + aux + reference;
      this.location.go(nuevaURL);
    } else {
      const index = nuevaURL.indexOf('/');
      this.location.go(
        nuevaURL.substring(0, index) + '/orders/' + aux + reference
      );
    }

    this.order_reference = reference;
    this.orderService.searchOrder(this.order_reference)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
      next: (data) => {
        this.orderData = data.data;
        this.setDefaultTab();
        let title = data.data.client?.name
          ? data.data.client?.name +
          ' ' +
          (data.data.client?.lastname ? data.data.client?.lastname : '')
          : data.data.broker.reference;
        this.titleService.setTitle(
          this.translate.instant('titles-menu-pages.' + this.title) +
          ' ' +
          title +
          '- DBM'
        );
        this.aux_showForm = true;
        this.showForm = true;
        this.alertService.close();
      },
      error: (error) => {
        this.alertService.error('swal_messages.order_not_found');
      },
    });
  }

  deleteOrder(reference: string): void {
    this.alertService
      .confirmation(
        'swal_messages.warning_confirm',
        'swal_messages.delete_order',
        'swal_messages.confirm'
      )
      .then((result) => {
        if (result.isConfirmed) {
          const currentPage = this.paginator.pageIndex + 1;
          this.order_reference = reference;
          this.orderService.deleteOrder(this.order_reference)
            .pipe(
              takeUntil(this.destroy$)
            )
            .subscribe(
            () => {
              this.alertService.successOk('swal_messages.complete_success');
              this.refreshOrdersData();
            },
            (error) => {
              this.alertService.error('swal_messages.order_delete_error');
              console.error('Error al eliminar el cliente:', error);
            }
          );
          this.alertService.close();
        }
      });
  }

  detectUrl = false;
  detectReference() {
    this.pageSize = Number(this.localStorageService.getItem('per_page'));
    this.pageNumber = Number(this.localStorageService.getItem('page'));
    this.sortColumn = String(this.localStorageService.getItem('sortColumn')) == "null" ? 'stage_updated_at' : String(this.localStorageService.getItem('sortColumn'));
    this.sortDirection = String(
      this.localStorageService.getItem('sortDirection')
    ) == "null" ? 'asc' : String(this.localStorageService.getItem('sortDirection'));
    // Capturar el parámetro 'tab'
    this.route.queryParams
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe((params) => {
      if (params['tab']) {
        this.tab = params['tab'];
      }
      // Pre-aplicar filtro de supplier desde queryParam
      if (params['supplier']) {
        this.filterInitialValues = { 'supplier_reference_id[eq]': params['supplier'] };
      }
    });

    // Obtener el tipo de cuenta del localStorage
    this.getAccountTypeFromLocalStorage();

    // Obtener la URL actual
    const nuevaURL = this.location.path();

    // Verificar si estamos en la ruta para mostrar el formulario
    this.aux_showForm = nuevaURL.includes('orders/contracts/add');

    let paramReference = this.route.snapshot.paramMap.get('reference');

    // ✅ FASE B5: Delegado a OrdersRouteService
    const routeConfig = this.ordersRouteService.detectAndSetOrderType(nuevaURL);
    this.preTypeOrders = routeConfig.preTypeOrders;
    this.typeOrders = routeConfig.typeOrders;
    this.stage_type = routeConfig.stage_type;
    this.location.go(routeConfig.newRoute);
    this.title = routeConfig.title;
    this.showAlertFilterAll = routeConfig.showAlertFilterAll;
    this.showAlertCancelled = routeConfig.showAlertCancelled;

    // Obtener la referencia de la orden
    if (paramReference === this.typeOrders) {
      paramReference = null; // Si la referencia es igual al tipo de orden, no hay referencia
    }
    if (paramReference === 'add') {
      paramReference = null; // Si la referencia es igual al tipo de orden, no hay referencia
    }
    if (paramReference) {
      this.order_reference = paramReference;
      this.detectUrl = true;
    }
    this.cargaladata.typeOrders = this.typeOrders;
  }

  onPageChange(event: PageEvent): void {
    this.pageNumber = event.pageIndex + 1;
    this.localStorageService.setItem('per_page', String(event.pageSize));
    this.pageSize = event.pageSize;
    this.fetchNewData();
  }

  toggleForm() {
    this.showForm = !this.showForm;
  }

  toggleFormPdf() {
    this.showFormPdf = !this.showFormPdf;
  }

  showPdfButton() {
    const statusColorMap: { [key: string]: boolean } = {
      'after-sales-factory': true,
      'after-sales-dealership': true,
      'after-sales-billing': true,
      'after-sales-registering': true,
      'after-sales-prepared': true,
      'after-sales-logistics': true,
      'after-sales-rejected': true,
      'after-sales-delivered': true,
    };
    return statusColorMap[this.typeOrders] || false;
  }

  cerrarFormulario() {
    this.formAddOrderComponent.closeViewOverlay();
    this.titleService.setTitle('Pedidos - DBM');
    const nuevaURL = this.location.path() + '/orders/' + this.typeOrders;
    const index = nuevaURL.indexOf('/');
    this.location.go(
      nuevaURL.substring(0, index) + '/orders/' + this.typeOrders
    );
    this.assignee = null;
    this.orderData = null;
    this.showForm = false;
    this.showFormPdf = false;
    this.showAssigneeForm = false;
    this.showAddressesForm = false;
    this.document_buttons_chico = false;
  }
  cerrarFormularioExcel() {
    this.showImportExcel = false;
    this.document_buttons_chico = false;
  }

  cerrarFormularioPdf() {
    this.titleService.setTitle('Pedidos - DBM');
    const nuevaURL = this.location.path() + '/orders/' + this.typeOrders;
    const index = nuevaURL.indexOf('/');
    this.location.go(
      nuevaURL.substring(0, index) + '/orders/' + this.typeOrders
    );
    this.showFormPdf = false;
    this.document_buttons_chico = false;
  }

  clientAutoAssign(event: any) {
    this.cerrarClienteFormulario();
    this.formAddOrderComponent.autoAssignClient(event);
  }


  cerrarClienteFormulario() {
    this.assignee = null;
    this.document_buttons_chico = false;
    this.showAddClientForm = false;
  }

  cerrarAssigneeFormulario() {
    this.assignee = null;
    this.document_buttons_chico = false;
    this.showAssigneeForm = false;
  }

  refrescar() {
    this.fetchData();
  }

  // ✅ FASE B2: Métodos de badge colors migrados a OrdersTableComponent

  getAccountTypeFromLocalStorage(): void {
    this.accountType = this.authStateService.getAccountType();
  }

  refreshOrdersData() {
    let apiCall: Observable<any>;

    apiCall = this.orderService.getFilterData(
      this.typeOrders,
      this.preTypeOrders,
      this.pageNumber,
      this.pageSize,
      this.searchParams,
      this.sortColumn,
      this.sortDirection
    );

    apiCall
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
      next: (data) => {
        this.ordersStateService.setOrders(data.data);
        
        this.dataSource.sort = this.sort;
        this.pageNumber = data.meta.current_page;
        if (!this.localStorageService.getItem('per_page')) {
          this.localStorageService.setItem('per_page', data.meta.per_page);
          this.pageSize = data.meta.per_page;
        } else {
          this.pageSize = Number(
            this.localStorageService.getItem('per_page')
          );
        }
        this.paginator.pageSizeOptions = [25, 50, 100];
        this.paginator.pageSize = this.pageSize;
        this.paginator.pageIndex = this.pageNumber - 1;
        this.paginator.length = data.meta.total;

        this.restoreSelections();

        this.showAlertResult(data.meta.total);
      },
      error: (error) => {
        this.alertService.error(error.error);
      },
    });
  }

  // ✅ FASE C1: Delegado a OrdersAlertService
  showAlertResult(count: any) {
    this.ordersAlertService.updateAlertState(
      count,
      this.searchParams,
      this.typeOrders,
      this.showAlertFilterAll,
      this.showAlertCancelled
    );
    this.cdr.detectChanges();
  }

  filterChanged(searchTerm: any) {
    this.alertService.loading('swal_messages.please_wait');
    this.searchParams = searchTerm;
    this.orderService
      .getFilterData(
        this.typeOrders,
        this.preTypeOrders,
        this.pageNumber,
        this.pageSize,
        this.searchParams,
        this.sortColumn,
        this.sortDirection
      )
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (data) => {
          this.ordersStateService.setOrders(data.data);
          
          this.dataSource.sort = this.sort;
          this.pageNumber = data.meta.current_page;
          if (!this.localStorageService.getItem('per_page')) {
            this.localStorageService.setItem('per_page', data.meta.per_page);
            this.pageSize = data.meta.per_page;
          } else {
            this.pageSize = Number(
              this.localStorageService.getItem('per_page')
            );
          }
          this.paginator.pageSizeOptions = [25, 50, 100];
          this.paginator.pageSize = this.pageSize;
          this.paginator.pageIndex = this.pageNumber - 1;
          this.paginator.length = data.meta.total;
          this.showAlertResult(data.meta.total);
          this.startAutoFetch();
          this.alertService.close();
        },
        error: (error) => {
          this.alertService.error(error.error);
        },
      });
  }
  openImportOptions() {
    this.showImportExcel = !this.showImportExcel;
  }

  // ✅ FASE B4: Exportación delegada a OrdersExportService
  async openExportOptions() {
    await this.ordersExportService.showExportDialog(
      this.accountType || '',
      this.typeOrders,
      this.searchParams,
      this.userRole
    );
  }

  // ✅ FASE B4: Exporta al formato especificado
  exportOrders(type: any, format: any) {
    this.ordersExportService.exportOrders(
      type,
      format,
      this.searchParams,
      this.typeOrders,
      this.userRole
    );
  }

  // ✅ FASE B2: getBadgeColorClient migrado a OrdersTableComponent

  selectAddresses(addresses: any) {
    this.showAddressesForm = false;
  }


  onSortChange(event: Sort) {
    let column = this.sortMap[String(event.active)];
    if (column == 'actions') {
      if (this.sort) {
        this.sort.direction = ''; // Esto evita que el ordenamiento se aplique visualmente
      }
    } else {
      this.pageNumber = 1;
      this.localStorageService.setItem('sortColumn', column);
      this.localStorageService.setItem(
        'sortDirection',
        String(event.direction)
      );
      this.sortColumn = event.active;
      this.sortDirection = event.direction == '' ? 'asc' : event.direction;
      this.fetchNewData();
    }
  }

  onSortChange2(event: string) {
    this.sortColumn = this.sortMap[String(event)];
    this.localStorageService.setItem('sortColumn', this.sortColumn);

    if (this.sortDirection == 'asc') {
      this.sortDirection = 'desc';
    } else {
      this.sortDirection = 'asc';
    }

    this.localStorageService.setItem('sortDirection', this.sortDirection);

    this.pageNumber = 1;
    this.fetchNewData();
  }

  // ✅ FASE B2: getDirection migrado a OrdersTableComponent

  showAssigneeCreateForm = false;

  @Output() assigneeCreated = new EventEmitter<any>();
  handleNewAssigneeInClients(newAssignee: any) {
    this.assigneeCreated.emit(newAssignee);
  }

  @Input() emitOpenAssigneeCreateForm = new EventEmitter<any>();

  openAssigneeCreateForm() {
    this.document_buttons_chico = true;
    this.showAssigneeCreateForm = true;
    this.emitOpenAssigneeCreateForm.emit(true);
  }

  closeAssigneeCreateForm() {
    this.showAssigneeCreateForm = false;
    this.showForm = true;
    this.refreshClients();
  }

  cerrarFormularioCreateAssignee() {
    this.showAssigneeCreateForm = false;
  }

  optAdd = 'client';
  assignee = null;

  openClientForm(optAdd: string) {
    this.document_buttons_chico = true;
    this.showAddClientForm = true;
    this.optAdd = optAdd;
  }

  closeClientForm() {
    this.assignee = null;
    this.document_buttons_chico = false;
    this.showAddClientForm = false;
  }

  openAssigneeForm(assignee: any) {
    this.assignee = assignee;
    this.document_buttons_chico = true;
    this.showAssigneeForm = true;
  }

  closeAssigneeForm() {
    this.assignee = null;
    this.document_buttons_chico = false;
    this.showAssigneeForm = false;
  }

  openAddressesForm() {
    this.document_buttons_chico = true;
    this.showAddressesForm = true;
  }

  closeAddressesForm() {
    this.showAddressesForm = false;
    this.document_buttons_chico = false;
  }

  openMailPanel(data: { reference: string; email: string; name: string }) {
    this.mailPanelData = data;
    this.document_buttons_chico = true;
    this.showMailPanel = true;
  }

  closeMailPanel() {
    this.showMailPanel = false;
    this.document_buttons_chico = false;
  }

  openCallPanel(data: { phone: string; name: string; clientReference: string }) {
    this.callPanelData = data;
    this.showCallPanel = true;
    this.document_buttons_chico = true;
  }

  closeCallPanel() {
    this.showCallPanel = false;
    this.document_buttons_chico = false;
  }

  closeSubPanels() {
    this.showMailPanel = false;
    this.showCallPanel = false;
    this.document_buttons_chico = false;
  }

  refreshClients() {
    this.assignee = null;
    this.showAddClientForm = false;
    this.document_buttons_chico = false;
  }

  handleClickDocument(url: string) {
    this.alertService.loading('swal_messages.please_wait_documents');
    const a = document.createElement('a');
    a.href = url;
    a.click();
    setTimeout(() => {
      this.alertService.close();
    }, 1000);
  }

  currentRoute: string = '';

  private detectCurrentRoute(): void {
    this.currentRoute = this.ordersRouteService.detectCurrentRoute(this.router.url);
  }

  shouldHideDeliveryBadge(): boolean {
    return this.accountType === 'broker' && this.isAfterSalesView();
  }

  // 🔥 MÉTODO PARA DETECTAR VISTAS DE POSTVENTA
  private isAfterSalesView(): boolean {
    // ✅ FASE B5: Delegado a OrdersRouteService
    return this.ordersRouteService.isAfterSalesView(this.router.url);
  }


  defaultTab: string = 'general';

  private setDefaultTab(): void {
    if (this.forceTab) {
      this.defaultTab = this.forceTab;
      this.forceTab = null;
    } else if (this.userRole === 'Telemarketing' || this.typeOrders === 'telemarketing-pending') {
      this.defaultTab = 'telemarketing';
    } else {
      this.defaultTab = 'general';
    }
  }

  mostramos(): boolean {
    if (!this.stage_type.includes('telemarketing') && this.accountType == 'supplier') {
      return false;
    }
    return (
      this.userRole == 'Telemarketing' || this.userRole !== 'Telemarketing'
    );
  }

  // ✅ FASE B6: Selección delegada a OrdersSelectionService

  isAllSelected(): boolean {
    return this.ordersSelectionService.areAllSelected(this.dataSource.data);
  }

  masterToggle(): void {
    this.ordersSelectionService.toggleAll(this.dataSource.data);
  }

  async openBulkStageUpdateModal() {
    if (!this.ordersSelectionService.hasSelection()) {
      this.alertService.warning('swal_messages.no_orders_selected');
      return;
    }
    const selectedReferences = this.ordersSelectionService.getSelectedReferences();
    const count = selectedReferences.length;

    this.alertService.loading('swal_messages.please_wait');

    this.orderService.getAvailableStages(this.typeOrders).pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: async (response) => {
        this.alertService.close();
        const stages = response.data || [];

        const [title, message, confirmText, cancelText] = await Promise.all([
          this.translate.get('swal_messages.bulk_update.title').toPromise(),
          this.translate.get('swal_messages.bulk_update.message').toPromise(),
          this.translate.get('buttons.confirm_stage_change').toPromise(),
          this.translate.get('buttons.cancel').toPromise(),
        ]);

        let swalOptions: { [key: string]: string } = {};
        stages.forEach((stage: any) => {
          const key = stage.key || stage.name || stage;
          const label = this.translate.instant('badge-status_select-stage.' + key) || key;
          swalOptions[key] = label;
        });

        const textContent = `${message} ${count} pedido(s).`;
        Swal.fire({
          title: title,
          text: textContent,
          icon: 'question',
          input: 'select',
          inputOptions: swalOptions,
          inputPlaceholder: this.translate.instant('inputs.select_stage'),
          inputValue: '',
          showCancelButton: true,
          confirmButtonText: confirmText,
          cancelButtonText: cancelText,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          inputValidator: (value) => {
            if (!value) {
              return this.translate.instant('swal_messages.select_stage_required');
            }
            return null;
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.confirmBulkUpdate(selectedReferences, result.value);
          } else {
            this.ordersSelectionService.clearSelection();
          }
        });
      },
      error: () => {
        this.alertService.close();
        this.alertService.error('swal_messages.error_loading_stages');
      }
    });
  }

  confirmBulkUpdate(references: string[], newStage: string): void {
    this.alertService.loading(this.translate.instant("swal_messages.bulk_update_loading"));
    const payload = {
      references: references,
      stage: newStage,
    };

    this.orderService.bulkUpdateStage(payload)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
      next: (response) => {
        this.alertService.close();
        this.alertService.success(this.translate.instant("swal_messages.bulk_update_success"));
        this.ordersSelectionService.clearSelection();
      },
      error: (error) => {
        this.alertService.close();
        this.alertService.error(this.translate.instant("swal_messages.bulk_update_error"));
        this.ordersSelectionService.clearSelection();
      },
    });
  }

  private restoreSelections(): void {
    this.ordersSelectionService.restoreSelections(this.dataSource.data);
  }

  toggleRowSelection(row: any): void {
    this.ordersSelectionService.toggle(row.reference);
  }

  // ✅ FASE B1: Métodos helper para estado centralizado

  // ✅ FASE B6: Obtiene tamaño de selección desde servicio
  get selectedReferencesSize(): number {
    return this.ordersSelectionService.getSelectedCount();
  }

  getOrdersCount(): number {
    return this.ordersStateService.getCurrentOrders().length;
  }

  hasOrders(): boolean {
    return this.getOrdersCount() > 0;
  }

  getOrderByReference(reference: string): Orders | undefined {
    return this.ordersStateService.findByReference(reference);
  }

  /**
   * Handler para clic en fila de la tabla
   * ✅ FASE B2: Nuevo método para integración de OrdersTableComponent
   */
  onRowClick(order: Orders): void {
    this.expandedRow = order;
    // Aquí se puede agregar lógica adicional al hacer clic en una fila
  }

  /**
   * Handler para eventos de cambio en la selección de la tabla
   * ✅ FASE B2: Método renombrado de onSelectionChange a handleSelectionChange
   */
  handleSelectionChange(): void {
    // Este método se puede expandir según necesidades futuras
    // Por ahora, solo se usa para mantener la reactividad
  }

  // ✅ FASE C1: Helper methods delegados a OrdersAlertService

  getEstimatedFilterMessage(): string {
    return this.ordersAlertService.getEstimatedFilterMessage();
  }

  getGeneralFilterMessage(): string {
    return this.ordersAlertService.getGeneralFilterMessage(this.typeOrders);
  }
}
